'use client'

import { Inter } from 'next/font/google'

const inter = Inter({ subsets: ['latin'] })

type Props = Readonly<{
  error: Error & { digest?: string }
}>

export default function GlobalError({ error }: Props) {
  // Check if it's a chunk load error
  const isChunkError =
    error.message.includes('ChunkLoadError') || error.message.toLowerCase().includes('failed to fetch')

  const handleReload = () => {
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.set('reload', Date.now().toString()) // Cache-busting param
    window.location.href = currentUrl.toString()
  }
  

  return (
    <html lang="en">
      <body className={`${inter.className}`}>
        <main>
          <div className="login">
            <div className="login-container">
              <div className="login-container__top">
                <div className="primary-logo big">
                  <span className="icon">
                    <img src="/assets/marbles_symbol-white.webp" alt="Marbles" />
                  </span>
                </div>
              </div>
              <div className="login-container__inner">
                <div className="login__header">
                  <span>Marbles Platform</span>
                </div>
                <div className="login__subheader">
                  <p>
                    {isChunkError
                      ? 'A new version of the platform is available. Please refresh the page.'
                      : error.message || 'An unexpected error occurred.'}
                  </p>
                </div>
                <button
                  className="btn btn--error"
                  type="button"
                  onClick={handleReload}
                >
                  <span>{isChunkError ? 'Reload' : 'Try again'}</span>
                </button>
              </div>
            </div>
          </div>
        </main>
      </body>
    </html>
  )
}
